export default [
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import(/* webpackChunkName: "kpi" */ '@/view/notification/index.vue'),
  },
  {
    path: '/notifications-assessment',
    name: 'notifications-assessment',
    component: () => import(/* webpackChunkName: "kpi" */ '@/view/notification/assessment.vue'),
  },
];
